import React, { useState } from "react";
import { ChevronLeft } from "lucide-react";
import { useDispatch } from "react-redux";
import { showToast } from "../../../../../Helper/Toast";
import { hitCreateStripeConnectProfessionalApi } from "../../../../../Redux/Professional/CreateStripeConnectProfessionalSlice";
import logo from "../../../../../assets/img/SimpleRenovate.svg";
import "./ConnectSquare.scss";

const SquareMark = () => (
  <svg
    className="square-connect__mark"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    aria-hidden
  >
    <rect x="2" y="2" width="44" height="44" rx="11" fill="#111111" />
    <rect x="11" y="11" width="26" height="26" rx="3" fill="#ffffff" />
    <rect x="17" y="17" width="14" height="14" rx="2" fill="#111111" />
  </svg>
);

const ConnectSquare = ({ onBack }) => {
  const dispatch = useDispatch();
  const [connecting, setConnecting] = useState(false);

  const handleConnectNow = () => {
    const squareUrl =
      typeof process !== "undefined" &&
      process.env &&
      process.env.REACT_APP_SQUARE_CONNECT_URL;

    if (squareUrl) {
      window.open(squareUrl, "_blank", "noopener,noreferrer");
      return;
    }

    setConnecting(true);
    dispatch(
      hitCreateStripeConnectProfessionalApi({ enableStripe: true })
    ).then((response) => {
      setConnecting(false);
      if (response.payload && response.payload.status === true) {
        showToast("Opening payment connection…", "success");
        window.open(response.payload.data.url, "_blank", "noopener,noreferrer");
      } else {
        showToast(
          response.payload?.message ||
            "Unable to start connection. Try again later.",
          "error"
        );
      }
    });
  };

  return (
    <div className="square-connect">
      <header className="square-connect__header">
        <button
          type="button"
          className="square-connect__back"
          onClick={onBack}
          aria-label="Back to settings"
        >
          <ChevronLeft size={28} strokeWidth={2} />
        </button>
        <div className="square-connect__header-logo">
          <img src={logo} alt="Simple Renovate" className="square-connect__brand-img" />
        </div>
        <span className="square-connect__header-spacer" aria-hidden />
      </header>

      <main className="square-connect__body">
        <div className="square-connect__brand-row">
          <SquareMark />
          <span className="square-connect__brand-name">Square</span>
        </div>
        <h1 className="square-connect__title">Connect Square Account</h1>
        <p className="square-connect__copy">
          If you would like to have the ability to collect payments from your
          clients. Please link your account below.
        </p>
      </main>

      <footer className="square-connect__footer">
        <button
          type="button"
          className="square-connect__cta"
          onClick={handleConnectNow}
          disabled={connecting}
        >
          {connecting ? "Please wait…" : "Connect Now"}
        </button>
      </footer>
    </div>
  );
};

export default ConnectSquare;
